import { useSessionManager } from '../../hooks/useSessionManager/useSessionManager';

const SessionManger = () => {
    useSessionManager();

    return '';
};

export default SessionManger;
